// 前海饿了么状态枚举
export const qhElemeReportStatus = [{
  value: 1,
  id: 'ONLINE_INFO_TO_BE_SUBMITTED_TO_INSURE_COMPANY',
  label: '资料待提交'
}, {
  value: 2,
  id: 'ONLINE_INFO_CHECKING',
  label: '电子资料审核中'
}, {
  value: 3,
  id: 'ONLINE_INFO_TO_BE_ADDED',
  label: '待补充电子资料'
}, {
  value: 4,
  id: 'PAPER_INFO_TO_BE_ADDED',
  label: '待补充纸质资料'
}, {
  value: 5,
  id: 'PAPER_INFO_CHECKING',
  label: '纸质资料审核中'
}, {
  value: 6,
  id: 'APPLY_UNAPPROVED',
  label: '拒赔'
}, {
  value: 7,
  id: 'CASE_CLOSED_WITH_NO_PAY',
  label: '0结'
}, {
  value: 8,
  id: 'ACCOUNT_COMPLETE',
  label: '赔付成功'
}, {
  value: 9,
  id: 'CANCEL',
  label: '撤案'
}, {
  value: 10,
  id: 'CANCEL_BY_INSURE_COMPANY',
  label: '注销'
}]